export default {

    

    // Masters

    andrii_pavlov: "Андрій",

    andrii_pavlov_details: 
    '" Вожу Підземелля та Дракони вже близько 5 років. Через мою ширму пройшли десятки, якщо не сотні гравців, деякі з них вже самі стали на шлях свавілля Майстра. Люблю D&D та інші рольові системи за можливість поринути у світ магії та чудес, де кожен може стати героєм (або злодієм, я не засуджую). Деякі з ігор викладаю на створеному зі своїми друзями ютуб-каналі <a target="_blank" href="https://www.youtube.com/idearoll">idearoll</a>. "',

    andrii_pavlov_contact: 
    '<a target="_blank" href="https://t.me/godblessdnd">@godblessdnd</a>',

    //-----

    oleksandr_frankivsky: "Олександр",

    oleksandr_frankivsky_details: 
    '" Я Майстер настільно-рольових ігор вже протягом 5 років. Я віддаю перевагу ігровому досвіду, який здатен занурити вас в незабутні пригоди та принести приємні емоції. Також я один з спів ведучих ютуб каналу <a target="_blank" href="https://www.youtube.com/@tepli-nastolki">Теплі Настолки</a>, де роблю огляди систем та гайди. "',

    oleksandr_frankivsky_contact: 
    '<a target="_blank" href="https://t.me/Lagoni">@Emperf</a>',

    //-----

    sanech: "Саша",

    sanech_details: '" Я хочу познайомити зі світом ДнД так багато людей як зможу, адже тут для кожного знайдеться його власна історія, яку ви напишете власноруч. На початку книги ви ніколи не знаєте чим вона закінчиться, що чекатиме персонажів, як вони будуть досягати результату, хто залишиться з ними до кінця, а хто виявиться зрадником. Так і в світі ДнД — ми разом пишемо історію яка більше не повториться! "',

    sanech_contact: '<a target="_blank" href="https://t.me/SanechSanech">@SanechSanech</a>',
};
